import { Component, Input, Output, EventEmitter, ViewChild, ElementRef, OnChanges, SimpleChanges } from '@angular/core';
import { IGenomeTime } from 'bz-genome-angular/time-picker/time-picker/bzg-time-picker.component';
import { GenomeTimeService } from 'app/shared/services/genome-time.service';
import { EJobType } from '../job-type.enum';
import { BzgModalService, BzgToastService, BzgToastType } from 'bz-genome-angular';
import { DeleteConfirmationComponent } from 'app/shared/components/delete-confirmation/delete-confirmation.component';
import { TranslateService } from '@ngx-translate/core';
import { I18nService } from 'i18n/i18n.service';
// import { IJob } from '../IJob';
import { DateUtil } from 'app/core/utils/DateUtil';
import { AIJobsService } from 'app/ai-job/ai-jobs.service';
import { IUserJob } from 'app/ai-job/core/IUserJob';
@Component({
  selector: 'job-settings',
  templateUrl: 'job-settings.component.html',
  styleUrls: ['job-settings.component.scss']
})
export class JobSettingsComponent implements OnChanges{

  public enableSchedule: boolean = true;

  @Input() applyDisabled = false;
  @Input() currentJob: IUserJob;
  @Input() jobType: EJobType;

  @Output() saveJob = new EventEmitter<IUserJob>();
  @Output() cancel = new EventEmitter();
  @Output() reset = new EventEmitter();

  public showReset: boolean = false;
  public nextRuntimeDate: Date;
  public dateMax: Date= new Date();
  public jobStates: { [key: string]: { rescheduleJob: boolean, switchActivated: boolean, originalNextRuntimeDate: Date, nextRuntimeDate: Date } } = {};

  @ViewChild('dpTo', { static: false }) dpTo: any;

  constructor(private _modalService: BzgModalService,
    private _userJobService: AIJobsService,
    private _toastService: BzgToastService,
    private _i18nService: I18nService) {
    this.dateMax.setFullYear(this.dateMax.getFullYear() + 10);
  }
  ngOnChanges(changes: SimpleChanges): void {
  }

  changeEnableSchedule() {
    this.currentJob.enabled = !this.currentJob.enabled;
  }

  applyChanges() {
    this.saveJob.emit(this.currentJob);    
  }

  cancelChanges() {

  }
  

  changeFrequency(frequency) {    
    this.currentJob.schedules[0].frequency.type = frequency;
  }

  onDateChange(newValue) {
    const dateString = DateUtil.converDateToStringNoAddOffset(newValue);
    const dateToSave = DateUtil.addOffset(dateString, false, false);
    this.currentJob.schedules[0].startDate = dateToSave;
  }
}
